export class FormAutomation {
  private static isButton(element: ChildNode): boolean {
    return element.nodeName.toLowerCase() == "button";
  }

  private static isInput(element: ChildNode): boolean {
    return (
      element.nodeName.toLowerCase() == "input" ||
      element.nodeName.toLowerCase() == "select" ||
      element.nodeName.toLowerCase() == "textarea" ||
      element.nodeName.toLowerCase() == "button"
    );
  }

  private static getNextSiblingInput(element: ChildNode) {
    // console.log(`#001 try getNextSiblingInput`);
    if (element.nextSibling) {
      // console.log("#002 has next sibling");
      if (this.isInput(element.nextSibling)) {
        // console.log("#003 next sibling is input");
        return element.nextSibling;
      } else {
        // console.log("#004 next sibling is not input");
        const findInElementNext = this.getInputInChildNodes(
          element.nextSibling
        );
        if (findInElementNext) {
          // console.log("#005 found in child nodes");
          return findInElementNext;
        } // console.log("#006 not found in child nodes");
        else return this.getNextSiblingInput(element.nextSibling);
      }
    }
    return false;
  }

  private static getNextParentSiblingInput(element: ChildNode) {
    const parent = element.parentElement;
    // check if element has parent
    if (parent) {
      // console.log("#007 has parent");
      // check if parent has next sibling
      if (parent.nextSibling) {
        // console.log("#008 has parent.nextSibling");
        // check if parent's next has a next input
        let nextSiblingInput = this.getNextSiblingInput(parent);
        if (nextSiblingInput) {
          // console.log("#009 parent.nextSibling is input");
          // parent's next has a next input
          return nextSiblingInput;
        } else {
          /* console.log(
            "#010 parent.nextSibling is no input, check if child nodes are input"
          );*/
          // parent's next does not provide a next input
          // check if parent's next's children do have any
          let nextSiblingInput = this.getInputInChildNodes(parent.nextSibling);
          if (nextSiblingInput) {
            // console.log("#011 parents child nodes are input");
            // console.log(nextSiblingInput);
            // parent's next element has input in children
            return nextSiblingInput;
          } else {
            /* console.log(
              "#012 parents child nodes are no inputs, go out one level"
            );*/
            // parent's next element does not input children
            // go out one more level
            return this.getNextParentSiblingInput(parent);
          }
        }
      } else {
        // console.log("#013 parent does not have siblings, go out one level");
        // parent does not have next sibling
        // go out one level
        return this.getNextParentSiblingInput(parent);
      }
    } else {
      // console.log("#014 parent not found - i do not know what to do here");
    }

    return false;
  }

  private static getInputInChildNodes(element: ChildNode) {
    // check if element has children
    if (element.childNodes) {
      // console.log("#015 child nodes found - so run loop");
      // search in all elements
      const children = element.childNodes;
      for (let i = 0; i < children.length; i++) {
        // check if children is a input
        // console.log(`#016 exec loop #${i}`);
        if (this.isInput(children[i])) {
          return children[i];
        }

        // check if children has input inside its children
        const foundInput = this.getInputInChildNodes(children[i]);
        if (foundInput) return foundInput;
      }
    }

    return false;
  }

  public static FocusNextChild(event): void {
    setTimeout(() => {
      const input = event.target;

      // check if there is another input element inside the parentNode
      let next = this.getNextSiblingInput(input);
      if (next) {
        // there is another input element inside the parentNode
        // so focus it
        next.focus();
      } else {
        // there is no other input element inside the parentNode
        // check if the parentNode has nextElements and get
        let next = this.getNextParentSiblingInput(input);
        if (next) {
          // if input then focus
          this.focusOrClickElement(next);
        }
      }
    }, 10);
  }

  private static focusOrClickElement(element) {
    element.focus();
    if (this.isButton(element)) {
      element.click();
    }
  }
}
